import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import {Col, Container, Row} from 'react-bootstrap'
import {Link} from 'react-router-dom'

// import amaniCoffe from '../assets/amani-coffee.svg'
import slide1produkty from '../assets/amani-treasure.png'
// import slide1 from '../assets/slide1.png'
import PublicLayout from '../common/PublicLayout'

function KurzyPage() {
    return (
        <PublicLayout>
            <div className="d-flex min-h-100v-header align-items-center background-light-yellow">
                <Container fluid>
                    <Row>
                        <Col md={'5'}>
                            <img className={'w-100'} src={slide1produkty} style={{paddingTop: '55px'}}/>
                        </Col>
                        <Col md={'7'}>
                            <div className=" pe-md-5 text-left d-flex justify-content-center gap-4 flex-column h-100">
                                <h2>
                                    <span
                                        className="font-vollkorn fs-55">Amani Mentorka</span><br/><span
                                    className={'font-shantell color-pink-primary d-block'}
                                    style={{padding: '25px', paddingLeft: '6rem'}}>tajná truhlica asistentky</span>
                                </h2>
                                <h3>
                                    tvoja pokladnica nástrojov, kurzov a materiálov pre úspešnú prácu
                                </h3>
                                <div className="text-center">
                                    <Link to={'/kurzy-pri-kavicke'}>
                                        <button
                                            className="btn btn-primary pink-color background-dark-yellow color-pink-primary btn-amani w-auto d-inline-block text-uppercase mb-3">
                                            otvor truhlicu
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </PublicLayout>
    )
}

export default KurzyPage
